// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_GS4","cls2":"Search-cls2_OQB Search-cls1_GS4","fullWidth":"Search-fullWidth_lHc"};